<!--
  @Description: 摘要提交-H5
  @Author: GPT
-->
<template>
  <div class="main-container">
    <div class="main-header">
      <span>{{ '提交摘要' | dealLanguage('Abstract Submission') }}</span>
      <Button v-if="user_key" type="primary" class="view-btn" @click="$router.push({ name: 'contributionList' })">
        {{ '查看已提交的摘要' | dealLanguage('View Submitted Abstracts') }}
      </Button>
    </div>
    <div class="center-wrapper">
      <div class="form-view">
        <Form ref="current-form" :model="currentForm" :rules="ruleValidate">
          <template v-if="language == 'zh'">
            <FormItem prop="mobile" :label="'手机号' | dealLanguage('Mobile Number')">
              <div class="mobile-ipt">
                <span
                  :class="['area-number', isVerifyCode && 'dis']"
                  @click="handleShowPicker"
                >
                  +{{ currentForm.mobileAreaCode }} &gt;
                </span>
                <Input
                  type="text"
                  class="right-padding"
                  v-model="currentForm.mobile"
                  :disabled="isVerifyCode"
                  :placeholder="'请输入手机号' | dealLanguage('Please enter your mobile number')"
                  autocomplete="off"
                ></Input>
                <Captcha
                  ref="captcha"
                  scene="vbdata_loginon"
                  :mobile="currentForm.mobile"
                  :mobileAreaCode="currentForm.mobileAreaCode"
                  v-if="!isVerifyCode"
                  captchaButtonId="abstract-captcha-button-mobile"
                  captchaElementId="abstract-captcha-element-mobile"
                ></Captcha>
                <Button type="text" class="code-btn" v-else @click="handleUpdateAccount">
                  {{ '更新手机号' | dealLanguage('Update Mobile') }}
                </Button>
              </div>
            </FormItem>
            <FormItem prop="verifyCode" :label="'验证码' | dealLanguage('Verification Code')">
              <Input
                type="text"
                v-model="currentForm.verifyCode"
                :disabled="isVerifyCode"
                :placeholder="'请输入验证码' | dealLanguage('Please enter the verification code')"
              ></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>{{ '验证成功' | dealLanguage('Verified') }}</span>
              </div>
            </FormItem>
            <FormItem prop="email" label="Email">
              <Input
                type="text"
                v-model="currentForm.email"
                :placeholder="'请输入联系邮箱' | dealLanguage('Please enter your email')"
              ></Input>
            </FormItem>
          </template>
          <template v-else>
            <FormItem prop="email" label="Email">
              <Input
                type="text"
                class="right-padding"
                :disabled="isVerifyCode"
                v-model="currentForm.email"
                placeholder="Please enter your email"
              ></Input>
              <Captcha
                ref="captcha"
                validMode="2"
                scene="vbdata_loginon"
                :email="currentForm.email"
                v-if="!isVerifyCode"
                captchaButtonId="abstract-email-captcha-button-mobile"
                captchaElementId="abstract-email-captcha-element-mobile"
              ></Captcha>
              <Button type="text" class="code-btn" v-else @click="handleUpdateAccount">
                Update E-mail
              </Button>
            </FormItem>
            <FormItem prop="verifyCode" label="E-mail Verification Code">
              <Input
                type="text"
                v-model="currentForm.verifyCode"
                :disabled="isVerifyCode"
                placeholder="Please enter the verification code"
              ></Input>
              <div class="verify-success" v-if="isVerifyCode">
                <i class="iconfont">&#xe71d;</i>
                <span>Verification successful</span>
              </div>
            </FormItem>
          </template>
          <FormItem
            prop="abstractTitle"
            :label="'摘要标题' | dealLanguage('Abstract Title')"
          >
            <Input
              type="text"
              v-model.trim="currentForm.abstractTitle"
              :placeholder="'请输入摘要标题' | dealLanguage('Please enter the abstract title')"
            ></Input>
          </FormItem>
          <FormItem prop="authors" :label="'作者信息' | dealLanguage('Authors')">
            <Input
              type="text"
              v-model.trim="currentForm.authors"
              :placeholder="'请输入作者信息' | dealLanguage('Please enter authors')"
            ></Input>
          </FormItem>
          <FormItem prop="affiliations" :label="'作者单位' | dealLanguage('Affiliations')">
            <Input
              type="text"
              v-model.trim="currentForm.affiliations"
              :placeholder="'请输入作者单位' | dealLanguage('Please enter affiliations')"
            ></Input>
          </FormItem>
          <FormItem
            prop="presentingAuthor"
            :label="'报告人' | dealLanguage('Presenting Author')"
          >
            <Input
              type="text"
              v-model.trim="currentForm.presentingAuthor"
              :placeholder="'请输入报告人姓名' | dealLanguage('Please enter the presenting author')"
            ></Input>
          </FormItem>
          <FormItem
            prop="abstractCategory"
            :label="'摘要类别' | dealLanguage('Abstract Category')"
          >
            <Input
              type="text"
              v-model.trim="currentForm.abstractCategory"
              :placeholder="'请输入摘要类别' | dealLanguage('Please enter the abstract category')"
            ></Input>
          </FormItem>
          <FormItem prop="abstractBody" :label="'摘要正文' | dealLanguage('Abstract Body')">
            <Input
              type="textarea"
              :rows="8"
              v-model.trim="currentForm.abstractBody"
              :placeholder="'请直接粘贴摘要正文' | dealLanguage('Please paste the abstract body directly')"
            ></Input>
            <div class="form-tip">
              <span>
                {{ '最多 500 字' | dealLanguage('Maximum 500 words') }}
              </span>
              <span :class="['word-count', abstractWordCount > 500 && 'danger']">
                {{ abstractWordCount }}/500
              </span>
            </div>
          </FormItem>
          <FormItem :label="'文件上传' | dealLanguage('Figure or Table')">
            <div class="upload-field">
              <input
                ref="fileInput"
                class="file-input"
                type="file"
                accept=".png,.jpg,.jpeg,.pdf"
                @change="handleFileChange"
              />
              <Button @click="triggerFileSelect">
                {{ '选择文件' | dealLanguage('Choose File') }}
              </Button>
              <div class="upload-text">
                {{
                  '1 张 Figure 或 1 个 Table（PNG、JPG、JPEG、PDF 等）'
                    | dealLanguage('1 Figure or 1 Table (PNG, JPG, JPEG, PDF)')
                }}
              </div>
            </div>
            <div class="upload-file" v-if="attachmentName">
              <span>{{ attachmentName }}</span>
              <Button type="text" @click="handleRemoveFile">
                {{ '删除' | dealLanguage('Remove') }}
              </Button>
            </div>
          </FormItem>
        </Form>
        <div class="btn-wrapper">
          <Button @click="handleSave" :loading="saveLoading">
            <span v-if="saveLoading">{{ '保存中' | dealLanguage('Saving') }}</span>
            <span v-else>{{ '保存' | dealLanguage('Save') }}</span>
          </Button>
          <Button type="primary" @click="handleSubmit" :loading="submitLoading">
            <span v-if="submitLoading">{{ '提交中' | dealLanguage('Submitting') }}</span>
            <span v-else>{{ '提交' | dealLanguage('Submit') }}</span>
          </Button>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        :default-index="defaultIndex"
        show-toolbar
        :columns="appMobileAreaCodeDtos"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        value-key="name"
      >
        <template #option="item">
          <div>+{{ item.mobileAreaCode }} ({{ item.countryName | dealLanguage(item.countryEnName) }})</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>
<script>
import { Alogin } from '@/service/app'
import { submitContribution, uploadContributionFile, getContributionList } from '@/service/vbef'
import Captcha from '@/components/common/captcha'
import { mapState } from 'vuex'
import filter from 'js/filter'

const MOBILE_REGEX = /^1[3-9]\d{9}$/

export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('提交摘要', 'Abstract Submission'),
    }
  },
  inject: ['wxShare'],
  components: {
    Captcha,
  },
  data() {
    const _this = this
    return {
      filter,
      saveLoading: false,
      submitLoading: false,
      isVerifyCode: false,
      showPicker: false,
      defaultIndex: 0,
      attachmentFile: null,
      uploadedFilePath: '',
      uploadedFileName: '',
      contributionId: 0,
      contributionStatus: null,
      currentForm: {
        activityId: 0,
        email: '',
        mobileAreaCode: '86',
        mobile: '',
        verifyCode: '',
        abstractTitle: '',
        authors: '',
        affiliations: '',
        presentingAuthor: '',
        abstractCategory: '',
        abstractBody: '',
      },
      ruleValidate: {
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.language == 'zh' && _this.currentForm.mobileAreaCode == '86') {
                return MOBILE_REGEX.test(value) ? Number(value) : false
              }
              return Number(value) || value
            },
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请填写邮箱', 'Please fill in your email'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The email format is incorrect'),
            trigger: 'blur',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入验证码',
              'Please enter the verification code'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateCode,
          },
        ],
        abstractTitle: [
          {
            required: true,
            message: filter.dealLanguage('请填写摘要标题', 'Please enter the abstract title'),
            trigger: 'blur',
          },
        ],
        authors: [
          {
            required: true,
            message: filter.dealLanguage('请填写作者信息', 'Please enter authors'),
            trigger: 'blur',
          },
        ],
        affiliations: [
          {
            required: true,
            message: filter.dealLanguage('请填写作者单位', 'Please enter affiliations'),
            trigger: 'blur',
          },
        ],
        presentingAuthor: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写报告人',
              'Please enter the presenting author'
            ),
            trigger: 'blur',
          },
        ],
        abstractCategory: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写摘要类别',
              'Please enter the abstract category'
            ),
            trigger: 'blur',
          },
        ],
        abstractBody: [
          {
            required: true,
            message: filter.dealLanguage(
              '请填写摘要正文',
              'Please enter the abstract body'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateAbstractBody,
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      uuserId: (state) => state.uuserId,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      isMobile: (state) => state.isMobile,
      vbef_path: (state) => state.vbef_path,
    }),
    abstractWordCount() {
      return this.countWords(this.currentForm.abstractBody)
    },
    attachmentName() {
      if (this.attachmentFile) return this.attachmentFile.name
      return this.uploadedFileName
    },
  },
  async created() {
    await this.initContributionData()
    this.fillContactInfo()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('提交摘要-CSGCT', 'Abstract Submission-CSGCT'),
      linkurl: this.vbef_path + '/abstractForm',
    })
  },
  methods: {
    async initContributionData() {
      const contributionId = this.$route.query.id || (this.$route.params && this.$route.params.id)
      if (!contributionId) return
      await this.fetchContributionDetail(contributionId)
    },
    async fetchContributionDetail(id) {
      const res = await getContributionList({
        id,
        getCount: false,
        page: 1,
        size: 1,
      })
      if (res.code !== 0) {
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
        return
      }
      const contribution = (res.data && res.data.contributions && res.data.contributions[0]) || null
      if (contribution) {
        this.applyContributionData(contribution)
      }
    },
    applyContributionData(contribution) {
      if (!contribution) return
      this.contributionId = contribution.id || 0
      this.contributionStatus = contribution.status || null
      this.uploadedFilePath = contribution.filePath || ''
      this.uploadedFileName = this.getFileNameFromPath(contribution.filePath)
      this.currentForm = {
        ...this.currentForm,
        email: contribution.email || '',
        abstractTitle: contribution.title || '',
        authors: contribution.author || '',
        affiliations: contribution.compName || '',
        presentingAuthor: contribution.presentingAuthor || '',
        abstractCategory: contribution.type || '',
        abstractBody: contribution.content || '',
      }
    },
    fillContactInfo() {
      if (!this.user) return
      if (!this.user_key) return
      this.currentForm.mobile = this.user.mobile || ''
      this.currentForm.mobileAreaCode = this.user.mobileAreaCode || ''
    },
    countWords(text) {
      const matches = String(text || '').match(/[A-Za-z0-9]+(?:['’-][A-Za-z0-9]+)?|[\u4e00-\u9fa5]/g)
      return matches ? matches.length : 0
    },
    getFileNameFromPath(path) {
      if (!path) return ''
      const arr = String(path).split('/')
      return arr[arr.length - 1] || ''
    },
    validateAbstractBody(rule, value, callback) {
      if (this.countWords(value) > 500) {
        callback(
          new Error(filter.dealLanguage('摘要正文最多 500 字', 'Abstract body can contain up to 500 words'))
        )
        return
      }
      callback()
    },
    async validateCode(rule, value, callback) {
      if (this.isVerifyCode) {
        callback()
        return
      }
      const params = {
        loginPlatform: this.isMobile ? 9 : 8,
        type: this.language == 'zh' ? 2 : 11,
        email: this.currentForm.email || '',
        mobileAreaCode: this.currentForm.mobileAreaCode || '',
        mobile: this.currentForm.mobile || '',
        code: this.currentForm.verifyCode,
      }
      const res = await Alogin(params)
      if (res.code == 0) {
        this.$store.commit('updateUserKey', res.data.userKey)
        this.isVerifyCode = true
        callback()
      } else {
        this.$store.commit('updateUserKey', null)
        this.isVerifyCode = false
        callback(new Error(filter.dealLanguage(res.msg, res.enMsg || res.msg)))
      }
    },
    handleUpdateAccount() {
      this.$store.commit('updateUserKey', null)
      this.isVerifyCode = false
      this.currentForm.verifyCode = ''
      if (this.language == 'zh') {
        this.currentForm.mobile = ''
      } else {
        this.currentForm.email = ''
      }
    },
    handleShowPicker() {
      if (this.isVerifyCode) return
      this.showPicker = true
    },
    onConfirm(item) {
      this.currentForm.mobileAreaCode = item.mobileAreaCode
      this.showPicker = false
    },
    triggerFileSelect() {
      this.$refs.fileInput && this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const allowReg = /\.(png|jpg|jpeg|pdf)$/i
      if (!allowReg.test(file.name)) {
        this.$notify(
          this.language == 'zh'
            ? '仅支持 PNG、JPG、JPEG、PDF 文件'
            : 'Only PNG, JPG, JPEG and PDF files are supported'
        )
        event.target.value = ''
        return
      }
      this.attachmentFile = file
      this.uploadedFilePath = ''
      this.uploadedFileName = file.name
    },
    handleRemoveFile() {
      this.attachmentFile = null
      this.uploadedFilePath = ''
      this.uploadedFileName = ''
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    buildPayload(status = 'draft') {
      return {
        email: this.currentForm.email,
        mobileAreaCode: this.currentForm.mobileAreaCode,
        mobile: this.currentForm.mobile,
        abstractTitle: this.currentForm.abstractTitle,
        authors: this.currentForm.authors,
        affiliations: this.currentForm.affiliations,
        presentingAuthor: this.currentForm.presentingAuthor,
        abstractCategory: this.currentForm.abstractCategory,
        abstractBody: this.currentForm.abstractBody,
        filePath: this.uploadedFilePath,
        attachmentName: this.attachmentName,
        contributionId: this.contributionId,
        status,
      }
    },
    validateSaveFields() {
      if (
        !this.currentForm.email.trim() ||
        !this.currentForm.abstractTitle.trim() ||
        !this.currentForm.authors.trim() ||
        !this.currentForm.affiliations.trim()
      ) {
        this.$notify(
          this.language == 'zh'
            ? '保存前请至少填写邮箱、摘要标题、作者信息、作者单位'
            : 'Please fill in Email, Abstract Title, Authors and Affiliations before saving'
        )
        return false
      }
      return true
    },
    async ensureAttachmentUploaded() {
      if (!this.attachmentFile) return this.uploadedFilePath
      const res = await uploadContributionFile(this.attachmentFile)
      if (res.code !== 0) {
        throw new Error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      this.uploadedFilePath = res.data || ''
      this.uploadedFileName = this.attachmentFile.name
      this.attachmentFile = null
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
      return this.uploadedFilePath
    },
    buildSubmitParams(status) {
      return {
        id: this.contributionId || 0,
        xuserId: (this.user && this.user.id) || this.uuserId || 0,
        email: this.currentForm.email,
        title: this.currentForm.abstractTitle,
        author: this.currentForm.authors,
        compName: this.currentForm.affiliations,
        presentingAuthor: this.currentForm.presentingAuthor,
        type: this.currentForm.abstractCategory,
        content: this.currentForm.abstractBody,
        filePath: this.uploadedFilePath,
        status: this.contributionStatus == 1 ? 1 : status,
      }
    },
    async submitContributionByStatus(status) {
      await this.ensureAttachmentUploaded()
      const res = await submitContribution(this.buildSubmitParams(status))
      if (res.code !== 0) {
        throw new Error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
      const newId = res.extraData && (res.extraData.id || res.extraData.contributionId)
      if (newId) this.contributionId = Number(newId) || this.contributionId
      return res
    },
    async handleSave() {
      if (this.saveLoading) return
      if (!this.validateSaveFields()) return
      this.saveLoading = true
      try {
        if (!this.isVerifyCode) {
          this.$notify({
            type: 'warning',
            message:
              this.language == 'zh'
                ? '请先完成账号验证后再保存草稿'
                : 'Please complete account verification before saving the draft.',
          })
          return
        }
        await this.submitContributionByStatus(2)
        this.$router.push({ name: 'abstractSuccess', query: {from: 'save'} })
      } catch (error) {
        this.$notify(error.message || error)
      } finally {
        this.saveLoading = false
      }
    },
    handleSubmit() {
      if (this.submitLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (!valid) {
          this.$notify(
            filter.dealLanguage('存在未完善选项，请检查表单', 'Please complete the form before submitting')
          )
          return
        }
        this.submitLoading = true
        try {
          await this.submitContributionByStatus(1)
          this.$router.push({ name: 'abstractSuccess' })
        } catch (error) {
          this.$notify(error.message || error)
        } finally {
          this.submitLoading = false
        }
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
.main-header
  padding-top 0.2rem
  padding-bottom 0.2rem
  border-bottom 1px solid #eeeeee
  display flex
  justify-content space-between
  align-items center
  margin 0 0.4rem
  font-weight 700
  span
    font-size 0.36rem
    line-height 0.6rem
    color #333333
  .view-btn
    color #fff
    background-color #C8161D
    border-color #C8161D
    &:hover
      background-color #E24147
      border-color #E24147
.center-wrapper
  padding-top 0.3rem
  padding-bottom 0.6rem
  .top-tip
    margin 0 0.4rem
    font-size 0.26rem
    color #3D3D3D
    line-height 0.44rem
    text-align justify
  .mobile-ipt
    display flex
    align-items center
    .area-number
      color #333333
      cursor pointer
      white-space nowrap
      height 0.88rem
      line-height 0.88rem
      padding 0 0 0 15px
      background #f9f9f9
      border-radius 4px 0 0 4px
      &.dis
        background #f0f0f0
    >>> .ivu-input
      border-radius 0 4px 4px 0
  .verify-success
    margin-top 0.12rem
    color #19BE6B
    font-size 0.24rem
    line-height 0.32rem
    display flex
    align-items center
    gap 0.08rem
  .form-tip
    margin-top 0.04rem
    display flex
    justify-content space-between
    gap 0.12rem
    font-size 0.22rem
    color #999999
    line-height 1.2
    .word-count
      color #666666
      &.danger
        color #C8161D
  .upload-field
    .file-input
      display none
    .upload-text
      margin-top 0.16rem
      font-size 0.22rem
      line-height 0.32rem
      color #999999
  .upload-file
    margin-top 0.16rem
    min-height 0.72rem
    padding 0 0.2rem
    background #F7F8FA
    border-radius 0.08rem
    display flex
    align-items center
    justify-content space-between
    gap 0.16rem
    font-size 0.24rem
    line-height 0.32rem
  .btn-wrapper
    margin-top 0.4rem
    display flex
    justify-content center
    gap 0.2rem
    >>> .ivu-btn
      min-width 1.8rem
</style>
